import React, { useState, useEffect } from "react";
import NeoIconBlack from "../../../Images/svg/Neoo_icon_black.svg";
import { useSelector } from "react-redux";
import neoologov2 from "../../../Images/neoologov2.svg";

const NeoCardLink = ({ data }) => {
    const [link, setLink] = useState("/");
    useEffect(() => {
        let businessPageLink = "";
        if (data?.neooBusinessPageLink) {
            businessPageLink = data?.neooBusinessPageLink;
        }
        if (!businessPageLink && data?.businessStatus && data?.companyName && data?.status == "Active") {
            businessPageLink = process.env.REACT_APP_APPLICATION_URL + '/businesspage/' + data?.companySlug;
        }
        setLink(businessPageLink);
    }, [data])
    return (
        <>{link && (
            <a
                href={`${link}`}
                target="_blank"
                className="bgsocial"
            >
                <img src={neoologov2} alt="Neoo business link" title="Neoo Business Page Link" style={{ width: "80%" }} />
            </a>
        )}
        </>
    );
}
export default NeoCardLink;